// extracted by mini-css-extract-plugin
export default {"InputComponent":"Input_InputComponent__5g8e9","label":"Input_label__RFYyY","InputStyles":"Input_InputStyles__miewc"};